import BPDocuments from "components/shared/BPPanelSettings/BPDocuments";

const BPDocumentContainer = () => {
    return <BPDocuments />;
};

export default BPDocumentContainer;
